// 配送料のテキスト
// https://www.notion.so/balusco/59bcc5b3eafb44dab166cb2e80406247#01fca46ae07f48d5978f3e99586934b2
export const SHIPPING_FEE_LABEL = "送料･手数料";
